<template>
  <div>
    <van-sticky :offset-top="46">
      <van-search
        v-model="queryParams.productName"
        shape="round"
        show-action
        background="#4fc08d"
        clearable
        placeholder="请输入搜索关键词"
      >
        <template #action>
          <div style="padding: 0px 4px;" @click="handleRefresh">搜索</div>
        </template>
      </van-search>
    </van-sticky>
    <no-page-list ref='pageList' :request-url="'/ordersub/stockUp/list/'+subId" :getParams="getQueryParams">
      <template #row="{row}">
        <van-row style="background-color:rgba(172,201,220,0.19);line-height: 32px;border-radius: 6px;padding: 6px 10px">
          <van-col span="24">商品名称: {{row.productName}}</van-col>
          <van-col span="12">销售单价: {{row.price}}</van-col>
          <van-col span="12">销售数量: {{row.quantity}} <van-tag type="success">{{row.unit}}</van-tag></van-col>
          <van-col span="12">销售金额: {{row.amount}}</van-col>
          <van-col span="12">结算单价: {{row.supplierPrice}}</van-col>
          <van-col span="12">采购单价: {{row.finalPrice}}</van-col>
          <van-col span="12">发货数量: {{row.deliverQuantiy}} <van-tag type="success">{{row.unit}}</van-tag></van-col>
          <van-col span="12">结算金额: {{row.supplierAmount}}</van-col>
          <van-col span="12">发货差额: <span :class="row.deliverDiversity !== 0? 'loss':''" >{{row.deliverDiversity}}</span></van-col>
          <van-col span ='24'>
            <van-cell style="border-radius: 6px">
              <template #title>
                <div style="line-height: 32px;font-weight: 500;font-size: 16px">盈亏: <span style="font-size: 20px" :class="row.income>0? 'profit':'loss'" >{{row.income}}</span></div>
              </template>
              <template #default >
                <van-button v-has="'STAT:PURCHASE'" type="info" size="small" style="padding: 0px 12px;font-size: 16px;border-radius: 6px" @click="openAdjustPurchase(row)" >调整</van-button>
              </template>
            </van-cell>
          </van-col>
        </van-row>
      </template>
    </no-page-list>
    <down-drawer ref='purchaseDrawer' @close="handleRefresh" @confirm="adjustPurchaseInfo" title="调整配货信息" >
      <template #content>
        <van-form ref="form" :validate-first="true" :show-error-message="false">
          <van-field
            name="finalPrice"
            label="采购单价"
            input-align ='right'
            :rules="[{ required: true, message: '采购单价不能为空' }]">
            <template #input>
              <van-stepper v-model="model.finalPrice" step="0.1" :decimal-length="2" :input-width ='64' :min="0.1"/>
            </template>
          </van-field>
          <van-field
            name="deliverQuantiy"
            label="发货数量"
            input-align ='right'
            :rules="[{ required: true, message: '发货数量不能为空' }]">
            <template #input>
              <van-stepper v-model="model.deliverQuantiy" step="0.1" :decimal-length="2" :input-width ='64' :min="0.1"/>
            </template>
          </van-field>
        </van-form>
      </template>
    </down-drawer>
  </div>
</template>

<script>
import NoPageList from '@/components/tools/NoPageList'
export default {
  name: 'StockUpList',
  components: { NoPageList },
  created () {
    const id = this.$route.params && this.$route.params.subId
    if (id) {
      this.subId = id
    }
  },
  data () {
    return {
      subId: null,
      model: {},
      queryParams: {
        productName: null
      }
    }
  },
  computed: {

  },
  methods: {
    getQueryParams (params) {
      const param = Object.assign({}, params)
      param.productName = this.queryParams.productName
      return param
    },
    handleRefresh () {
      this.$refs.pageList.onRefresh(20, false)
    },
    openAdjustPurchase (row) {
      this.model = Object.assign({}, row)
      this.$refs.purchaseDrawer.show = true
    },
    adjustPurchaseInfo () {
      if (!this.model.finalPrice || isNaN(this.model.finalPrice)) {
        this.$toast.fail('无效的采购单价')
        return
      }
      if (!this.model.deliverQuantiy || isNaN(this.model.deliverQuantiy)) {
        this.$toast.fail('无效的配送数量')
        return
      }
      // 触发表单验证
      this.$refs.form.validate().then(() => {
        this.$api.shop.updateStockUpList(this.subId, [this.model]).then(response => {
          this.$toast.success('操作成功')
          this.$refs.purchaseDrawer.show = false
        }).catch(() => {
        })
      }).catch((err) => {
        console.log('验证失败', err)
      })
    }
  }

}
</script>

<style lang="less" scoped>
  .avatar{
    width: 84px;
    height: 84px;
    vertical-align: middle;
    padding: 8px 0px;
    border-radius: 50%;
  }
  .profit {
    color: #07c160;
  }
  .loss {
    color: #ee0a24;
  }
</style>
